module.exports = __webpack_public_path__ + "img/protocol.79196964.svg";